import svg4everybody from 'svg4everybody';

$(() => {
	svg4everybody();

	const FIELD_NOT_EMPTY_CLASSNAME = 'form-field__input_not-empty';
	function updateField($input) {
		if ($input.val()) {
			$input.addClass(FIELD_NOT_EMPTY_CLASSNAME);
		} else {
			$input.removeClass(FIELD_NOT_EMPTY_CLASSNAME);
		}
	}
	$('.form').each(function initForm() {
		const $form = $(this);
		const $fields = $form.find('.form-field');

		$fields.each((i, field) => {
			const $field = $(field);
			const $input = $field.find('.form-field__input');

			$input.keyup(() => {
				updateField($input);
			});
			updateField($input);
		});
	});

	const $programs = $('.program');
	const PROGRAM_DAY_ACTIVE_CLASS = 'program-day_active';
	const PROGRAM_CONTENT_ACTIVE_CLASS = 'program-content__item_active';
	$programs.each(function initProgram() {
		const $program = $(this);
		const $dayWrappers = $program.find('.program-days__item');
		const $days = $dayWrappers.children('.program-day');
		const $contents = $program.find('.program-content__item');

		$dayWrappers.each(function activateProgramContent() {
			const $dayWrapper = $(this);
			const number = $dayWrapper.data('item');
			const $day = $dayWrapper.children('.program-day');
			const $targetContent = $contents.filter(`*[data-item=${number}]`);

			$day.click(() => {
				$days.removeClass(PROGRAM_DAY_ACTIVE_CLASS);
				$day.addClass(PROGRAM_DAY_ACTIVE_CLASS);

				$contents.removeClass(PROGRAM_CONTENT_ACTIVE_CLASS);
				$targetContent.addClass(PROGRAM_CONTENT_ACTIVE_CLASS);
			});
		});
	});


	const $archiveTitle = $('.archive-fixed__title');
	const $archiveItems = $('.archive-fixed__items');
	const ARCHIVE_ITEMS_ACTIVE_CLASSNAME = 'archive-fixed__items_active';
	$archiveTitle.click(() => {
		$archiveItems.toggleClass(ARCHIVE_ITEMS_ACTIVE_CLASSNAME);
	});


	$('.media-item').fancybox({
		padding: 0,
		overlayOpacity: .9,
		openEffect: 'none',
		closeEffect: 'none',
		nextEffect: 'none',
		prevEffect: 'none',
		helpers: {
			title: {
				type: 'inside'
			}
		}
	});
	// const $medias = $('.media');
	// const GALLERY_SELECTOR = '.media__gallery .gallery';
	// $medias.each(function initMedia() {
	// 	const $media = $(this);
	// 	const $items = $media.find('.media-item');
		// const gallery = new Gallery($gallery);

		// $items.each((i, item) => {
		// 	const $item = $(item);

		// 	$item.click(() => {
		// 		gallery.show(i);
		// 	});
		// });
	// });

	const $participants = $('.participant');
	const participants = [];
	$participants.each((i, item) => {
		const $participant = $(item);
		const $name = $participant.find('.participant__name');
		const $organization = $participant.find('.participant__organization');
		const $job = $participant.find('.participant__job');

		const name = $name.text();
		const organization = $organization.text();
		const job = $job.text();

		const participant = {
			$element: $participant,
			name,
			organization,
			job,
			index: {
				name: name.toLowerCase().split(' '),
				organization: organization.toLowerCase(),
				job: job.toLowerCase()
			}
		};

		participants.push(participant);
	});

	const $participantsFilterInput = $('#participantsFilter');
	const cleanRegex = /[^а-яa-z0-9 ]/g;

	$participantsFilterInput.keyup(function onFilterInputChange() {
		const $input = $(this);
		const value = $input.val().toLowerCase();
		const clearValues = value.replace(cleanRegex, '').split(' ');
		const searchRegexps = clearValues.map((value) => {
			const searchPattern = '.*' + value.split('').join('.*') + '.*';
			const searchRegex = new RegExp(searchPattern);
			return searchRegex;
		});

		participants.forEach((item) => {
			const name = item.index.name;
			const $element = item.$element;

			const isSuitable = searchRegexps.every((regex) => {
				return name.some((part) => {
					return regex.test(part);
				});
			});

			if (isSuitable) {
				$element.show();
			} else {
				$element.hide();
			}
		});
	});

	const $youtubeFrames = $('.html iframe');
	$youtubeFrames.each((i, frame) => {
		const $window = $(window);

		const $frame = $(frame);
		const defaultWidth = parseInt($frame.attr('width'));
		const defaultHeight = parseInt($frame.attr('height'));
		const ratio = defaultHeight / defaultWidth;

		let lastFrameWidth = null;

		function resize() {
			const currentFrameWidth = $frame.width();

			if (currentFrameWidth != lastFrameWidth) {
				const newFrameHeight = currentFrameWidth * ratio;

				$frame.height(newFrameHeight);
				lastFrameWidth = currentFrameWidth;
			}
		}

		resize();
		$window.resize(resize);
	});
});



/** WEBPACK FOOTER **
 ** ./app/scripts/app.js
 **/